import {
	ComponentOptions,
	IComponentBindings,
	IQuerySuccessEventArgs,
	Initialization,
	QueryEvents
	} from 'coveo-search-ui';
import * as $ from 'jquery';
import { AtlasComponent } from "./../models/AtlasComponent";
import { IDynamicTextOptions, DynamicText } from "./../models/DynamicTextOptions";

export class QueryHero extends AtlasComponent {
	static ID = "QueryHero";
	private dynamicText: string;
	private fallbackText: string;
	static options: IDynamicTextOptions = {
		authorDefinedText: ComponentOptions.buildStringOption({
			defaultValue: "Showing results for \"{query}\""
		})
	};

	constructor(element: HTMLElement, options: IDynamicTextOptions, bindings: IComponentBindings) {
		super(element, QueryHero.ID, bindings);
		this.dynamicText = new DynamicText(element, QueryHero, options).generateText({ query: "<span></span>" });
		this.fallbackText = this.element.getAttribute("data-fallback-text");
		this.bind.onRootElement(QueryEvents.querySuccess, (data: IQuerySuccessEventArgs) => this.handleQuerySuccess(data));
	}

	private handleQuerySuccess(data: IQuerySuccessEventArgs) {
		const query = data.query.q || Coveo.state(this.root, 'q');
		if (query && query.length) {
			this.domElement.empty();
			this.domElement.setHtml(this.dynamicText);
			this.element.getElementsByTagName("span")[0].innerHTML = query;
		} else {
			this.domElement.empty();
			this.domElement.setHtml(this.fallbackText);
		}
	}
}

Initialization.registerAutoCreateComponent(QueryHero);



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/QueryHero.ts